// @module Tavanoteam.ProductSpecifications.ProductSpecification
define('Tavanoteam.ProductSpecifications.ProductSpecification.View'
	, [
		'ProductSpecification.Model'

		, 'tavanoteam_productspecifications_productspecification.tpl'

		, 'Backbone'
	]
	, function (
		ProductSpecificationModel

		, tavanoteam_productspecifications_productspecification_tpl

		, Backbone
	) {
		'use strict';

		// @class Tavanoteam.ProductSpecifications.ProductSpecification.View @extends Backbone.View
		return Backbone.View.extend({

			template: tavanoteam_productspecifications_productspecification_tpl

			, initialize: function (options) {
				this.pdpComponent = options.container.getComponent('PDP');

				this.model = new ProductSpecificationModel();

				var self = this;

				this.pdpComponent.on('afterShowContent', function () {
					self.fetchItemSpecification();
				});

				this.layoutComponent = options.container.getComponent('Layout');

				this.customProductPropertiesForSEO = null;

			}

			, fetchItemSpecification: function () {
				var self = this;
				var item = this.pdpComponent.getItemInfo().item,
					itemId = item.internalid,
					itemSpecification = item.custitem_item_specification;

				if (!!itemSpecification) {
					this.model.fetch({ data: { itemId: itemId } }).done(function (result) {
						self.properties = result;

						self.render();

						var itemSpecificationForSEO = [];

						_.each(self.properties , function(element){
				
								var customProductProperty = {
									"@type": "PropertyValue",
									"name": element['property'],
									"value": element['value']
								};
				
								itemSpecificationForSEO.push(customProductProperty);
								
							}
						);
				
						if(itemSpecificationForSEO && itemSpecificationForSEO.length > 0){
				
							self.customProductPropertiesForSEO = itemSpecificationForSEO;
						}

						self.layoutComponent.modifyViewJsonLd('ProductDetails.Full.View', function(json) {

							if(self.customProductPropertiesForSEO){
								json = _.extend(json, {
									additionalProperty: self.customProductPropertiesForSEO
								});
							}
							
							return jQuery.Deferred().resolve(json);
						});
					});
				}
			}

			//@method getContext @return Tavanoteam.ProductSpecifications.ProductSpecification.View.Context
			, getContext: function getContext() {
				//@class Tavanoteam.ProductSpecifications.ProductSpecification.View.Context
				this.properties = this.properties || [];

				return {
					properties: this.properties
				};
			}
		});
	});
